module.exports = __webpack_public_path__ + "static/img/core-item-3.95cd0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCodePhone/core-item-3.png
// module id = ir1p
// module chunks = 0